var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "border_color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "border_color_2",
    d: "M1.33333 15.9989V13.9989H14.6667V15.9989H1.33333ZM4 10.9412H4.82433L10.3577 5.41806L9.9385 4.99256L9.52317 4.58356L4 10.1169V10.9412ZM3 11.9412V9.69123L10.4732 2.2284C10.5697 2.13184 10.6793 2.05879 10.802 2.00923C10.9246 1.95967 11.0521 1.9349 11.1847 1.9349C11.3173 1.9349 11.4458 1.95967 11.57 2.00923C11.6942 2.05879 11.8081 2.13529 11.9115 2.23873L12.7128 3.05023C12.8163 3.14679 12.8911 3.2574 12.9372 3.38206C12.9833 3.50662 13.0063 3.6354 13.0063 3.7684C13.0063 3.89306 12.9829 4.01701 12.9362 4.14023C12.8894 4.26356 12.8149 4.37629 12.7128 4.4784L5.25 11.9412H3ZM10.3577 5.41806L9.9385 4.99256L9.52317 4.58356L10.3577 5.41806Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderColor);
export default __webpack_public_path__ + "static/media/border-color.93930b9ba0bcf415abd065666a4f9eb7.svg";
export { ForwardRef as ReactComponent };